import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Modal,
  Alert,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Switch from "react-switch";
function Subscription() {
  var history = useHistory();
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  const [allCategory, setAllCategory] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [amount, setAmount] = useState("");
  const [offerAmount, setOfferAmount] = useState("");
  const [gst, setGst] = useState("");

  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [catId, setCatId] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [show1, setShow1] = useState(false);
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [validity, setValidity] = useState("");
  function getData() {
    axios
      .get(
        `${Baseurl.baseurl5}/go-home-service/home-service-subscription/get-all-home-experts-subscription`
      )
      .then((res) => {
        console.log("categoiryeueye", res.data.data);
        setSpinner(false);
        setAllCategory(res.data.data);
        setSearchData(res.data.data);
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function searchRider(value) {
    let filteredData = [];
    searchData.map((val) => {
      if (val.Category.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setAllCategory(filteredData);
  }

  function addCategory() {
    let catFields = {
      name: name,
      description: desc,
      validity: validity,
      amount: amount,
      offerAmount: offerAmount,
      gst: gst,
    };

    axios
      .post(
        `${Baseurl.baseurl5}/go-home-service/home-service-subscription/create-home-experts-subscription`,
        catFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Created", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  function updateCategory() {
    let catFields = {
      name: name,
      description: desc,
      validity: validity,
      amount: amount,
      offerAmount: offerAmount,
      gst: gst,
    };
    axios
      .put(
        `${Baseurl.baseurl5}/go-home-service/home-service-subscription/update-home-experts-subscription/${catId}`,
        catFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }

  function deleteCategory() {
    axios
      .delete(
        `${Baseurl.baseurl5}/go-home-service/home-service-subscription/delete-home-experts-subscription/${catId}`
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }

  function updateFunction(val) {
    setShow(true);
    setCatId(val._id);
    setUpdateStatus(true);
    setAmount(val.Amount);
    setName(val.Name);
    setDesc(val.Description);
    setGst(val.Gst);
    setOfferAmount(val.OfferAmount);
    setValidity(val.Validity);
  }

  return (
    <Col lg={12}>
      <Modal
        size="lg"
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Test</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <h4>Are You Sure You Want to Delete This Subscription ?</h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              deleteCategory();
            }}
            className="btn btn-primary"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Add Subscription</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="row ">
              <div className="col-sm-2 mt-2">
                <label>
                  Name <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={name}
                  type="text"
                  className="form-control"
                  placeholder="enter name"
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="col-sm-2 mt-2">
                <label>
                  Description <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={desc}
                  type="text"
                  className="form-control"
                  placeholder="enter description"
                  onChange={(e) => setDesc(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-sm-2 mt-2">
                <label>
                  Validity <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={validity}
                  type="number"
                  className="form-control"
                  placeholder="enter Validity (no of days)"
                  onChange={(e) => setValidity(e.target.value)}
                  required
                />
              </div>
              <div className="col-sm-2 mt-2">
                <label>
                  Amount <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={amount}
                  type="number"
                  className="form-control"
                  placeholder="enter amount"
                  onChange={(e) => setAmount(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-sm-2 mt-2">
                <label>
                  Offer Amount <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={offerAmount}
                  type="number"
                  className="form-control"
                  placeholder="enter Offer Amount"
                  onChange={(e) => setOfferAmount(e.target.value)}
                  required
                />
              </div>
              <div className="col-sm-2 mt-2">
                <label>
                  Gst <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={gst}
                  type="number"
                  className="form-control"
                  placeholder="enter gst"
                  onChange={(e) => setGst(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {updateStatus ? (
            <button
              className="btn btn-primary"
              onClick={() => {
                updateCategory();
              }}
            >
              Update
            </button>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                addCategory();
              }}
            >
              Submit
            </button>
          )}
        </Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
          <button
            onClick={() => {
              setShow(true);
              setUpdateStatus(false);

              setAmount("");
              setDesc("");
              setGst("");
              setValidity("");
              setOfferAmount("");
              setName("");
            }}
            className="btn btn-primary"
          >
            Add Subscription
          </button>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>Name</strong>
                    </th>

                    <th>
                      <strong>Amount</strong>
                    </th>
                    <th>
                      <strong>Offer Amount</strong>
                    </th>
                    <th>
                      <strong>No Of Days</strong>
                    </th>

                    <th>
                      <strong>GST</strong>
                    </th>
                    <th>
                      <strong>Description</strong>
                    </th>
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allCategory &&
                    allCategory.map((val, key) => (
                      <tr key={val._id}>
                        <td>{val.Name}</td>
                        <td>{val.Amount}</td>
                        <td>{val.OfferAmount}</td>
                        <td>{val.Validity}</td>

                        <td>{val.Gst}</td>
                        <td>{val.Description}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  updateFunction(val);
                                }}
                              >
                                Update
                              </Dropdown.Item>

                              <Dropdown.Item
                                onClick={() => {
                                  setCatId(val._id);
                                  setShow1(true);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!allCategory && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero allCategory
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default Subscription;
